import React from "react";
import { useStateContext } from "../../context/AdminDashboard/MainContext";
import Modal from "../atoms/Modal";
import InputGroup from "../atoms/InputGroup";
import BtnModal from '../atoms/BtnModal'
const ModalProfile = ({ userData,roleIsUser }) => {
  const { showprofile, closeprofile, onchangeInput,profilebtn } = useStateContext();
  return (
    <>
      {showprofile ? (
        <Modal title={"ویرایش پروفایل من"} closeModal={closeprofile}>
          <div className="flex flex-col w-379 gap-5">
            <InputGroup
              placeholder="مانند علی میرهادی"
              label={"نام و نام خانوادگی"}
              iconName={"userF"}
              val={userData.name}
              onchange={onchangeInput}
              id={"name"}
            />
            <InputGroup
              placeholder="مانند 09175843681"
              label={"شماره تماس"}
              iconName={"call"}
              val={userData.number}
              onchange={onchangeInput}
              id={"number"}
              type={"text"}
            />
            {roleIsUser===false ?( <InputGroup
              placeholder="مانند 1234"
              label={"پین"}
              iconName={"call"}
              val={userData.password}
              onchange={onchangeInput}
              id={"password"}
              type={"text"}
            />):(null)}
           
            <InputGroup
              placeholder="مانند مدیر عامل"
              label={"سطح دسترسی"}
              val={userData.access}
              iconName={"level"}
              onchange={onchangeInput}
              id={"access"}
              type={"text"}
              disabled={true}
            />
          </div>
          <div className="flex items-center justify-end pt-5.5">
              <BtnModal text={"تایید و ثبت اطلاعات"} accept={profilebtn} />
            </div>
        </Modal>
      ) : null}
    </>
  );
};

export default ModalProfile;
